import { render, staticRenderFns } from "./unidades.vue?vue&type=template&id=0a3f8466&"
import script from "./unidades.vue?vue&type=script&lang=js&"
export * from "./unidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports